module.exports = __webpack_public_path__ + "img/tu_hezuob.c33472f1.png";